import Header from "./../header/Header.vue";
import Footer from "./../footer/Footer.vue";
import NewsGallery from "./../news-gallery/NewsGallery.vue";
import moment from "moment";

export default {
  name: "News",
  components: {
    Header,
    Footer,
    NewsGallery
  },
  data() {
    return {
      newsContent: "",
      newsTitle: "",
      newsDate: "",

      newsGalleryContent: "",
      newsGalleryLinks: []
    };
  },
  methods: {
    properDisplay() {
      if (this.$route.params.item == undefined) this.$router.push("/");
    },

    getNewsContent() {
      if (this.$route.params.item) {
        let prepareNewsContent = [];
        prepareNewsContent = this.$route.params.item.content.rendered.split(
          "wp-block-gallery"
        );
        this.newsContent = prepareNewsContent[0];
      }
      return this.newsContent;
    },

    getNewsTitle() {
      if (this.$route.params.item)
        return (this.newsTitle = this.$route.params.item.title.rendered);
    },

    getNewsDate() {
      if (this.$route.params.item)
        return (this.newsDate = moment(this.$route.params.item.date).format(
          "DD-MM-YYYY"
        ));
    },

    getNewsGallery() {
      if (this.$route.params.item) {
        this.newsContent = this.$route.params.item.content.rendered;
      }
      this.newsGalleryContent = this.newsContent.split("wp-block-gallery");
      let prepareNewsGalleryLinks = [];

      if (this.newsGalleryContent.length > 1)
        prepareNewsGalleryLinks = this.newsGalleryContent[1].match(
          /src="https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-ząćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ0-9()@:%_\+.~#?&\/\/\=]*)/gm /* eslint-disable-line */
        );

      prepareNewsGalleryLinks.forEach(link => {
        this.newsGalleryLinks.push(link.substring(5));
      });

      return this.newsGalleryLinks;
    }
  },
  created() {
    window.scrollTo({ top: 100, behavior: "smooth" });
    this.properDisplay();
    this.getNewsGallery();
  }
};
